var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4422_1498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69821 -0.0585938C3.02041 -0.0585938 2.47095 0.490875 2.47095 1.16868V16.7141C2.47095 17.3919 3.02041 17.9414 3.69821 17.9414H14.3345C15.0123 17.9414 15.5618 17.3919 15.5618 16.7141V4.8505L10.6527 -0.0585938H3.69821Z",
    fill: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5629 9.04581V4.85263L14.847 4.13672H11.3946C11.1212 4.13672 10.9844 4.46721 11.1776 4.66049L15.5629 9.04581Z",
    fill: "url(#paint0_linear_4422_1498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 -0.0585938L15.5624 4.8505H11.8806C11.2028 4.8505 10.6533 4.30103 10.6533 3.62323V-0.0585938Z",
    fill: "#A6C5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2893 8.94336H5.7439V9.76154H12.2893V8.94336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2893 10.5797H5.7439V11.3979H12.2893V10.5797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7439 12.2161H12.2893V13.0343H5.7439V12.2161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.653 13.8525H5.7439V14.6706H10.653V13.8525Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4422_1498",
    x1: 13.1084,
    y1: 9.04581,
    x2: 13.1084,
    y2: 4.03445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D6ACD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4422_1498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDocs);
export default __webpack_public_path__ + "static/media/icons_Docs.17d3398ef23b848bd24d91e7a257984b.svg";
export { ForwardRef as ReactComponent };